import React from "react"

import { Switch } from "components"
import { addInventory } from "services"

const InventoryRowSwitch = props => {
  const {
    food,
    option,
    loading,
    setLoading,
    outOfStock,
    setOutOfStock
  } = props

  const handleOutOfStock = async (checked) => {
    if (loading) return

    setLoading(true)

    setOutOfStock(checked)

    try {
      await addInventory(
        food._id,
        option._id,
        {
          quantity: 0,
          branchId: option.branchId,
          outOfStock: checked
        }
      )
    } catch (err) {
      console.log(err)

      setOutOfStock(prev => !prev)
    }

    setLoading(false)
  }

  return (
    <Switch
      checked={outOfStock}
      onClick={handleOutOfStock}
    />
  )
}

export default InventoryRowSwitch